/* global $, jQuery, pageInformation, SGAction, SGViewState */
import isDoubleClick from './is-double-click';

; (function ($) {
  $.fn.shopgateTermsModal = function (options) {
    const defaults = {
      offsetTop: 10,
      offsetBottom: 10,
    };

    options = options || {};
    options = $.extend(true, {}, defaults, options);

    return this.each(function () {
      const that = $(this);
      let modal = null;
      let menuBarVisible = false;

      that.click(function (e) {
        if (isDoubleClick(e)) {
          return false;
        }

        e.preventDefault();
        e.stopPropagation();

        const url = this.href;

        /**
         * Save the current state of the menuBar (visible or not) so that we can display
         * the menuBar again if it was visible before
         */

        if (typeof pageInformation !== 'undefined' && typeof pageInformation.menuBarVisible !== 'undefined') {
          menuBarVisible = pageInformation.menuBarVisible;
        }

        $.shopgate.ajax({
          type: 'POST',
          url,
          beforeSend: () => {
            $(document).trigger('shopgateFramework.waitingIndicator.show');
            if (menuBarVisible) {
              SGAction.hideMenuBar();
            }
          },
          success: (data) => {

            if (data.html) {
              const content = $(data.html).find('.terms-wrapper').html();
              modal = '<div class="modal terms-modal" role="dialog" aria-labelledby="myModalLabel">'
                + ' <div class="modal-dialog">'
                + '   <div class="modal-content">'
                + '     <div class="modal-header">'
                + '       <h4 tabindex="0" class="modal-title">&nbsp;</h4>'
                + '       <button type="button" class="close" data-dismiss="modal"><span>&times;</span><span class="sr-only">Close</span></button>'
                + '     </div>'
                + '     <div class="modal-body">'
                + '       <div class="terms-content">' + content + '</div>'
                + '     </div>'
                + '   </div>'
                + ' </div>'
                + '</div>';

              const browserHeight = window.innerHeight;
              const $termsModal = $(modal);
              const $termsModalHeader = $termsModal.find('.modal-header');
              const $termsModalTitle = $termsModal.find('.modal-title');
              const $termsModalContent = $termsModal.find('.modal-content');
              const $termsModalBody = $termsModal.find('.modal-body');
              const $categoryHeadline = $termsModal.find('.category-headline');

              // Append the new one
              $('body').append($termsModal);

              // Add headline
              $termsModalTitle.text($categoryHeadline.find('h1').text());
              $categoryHeadline.find('h1').remove();

              $termsModal.on('shown.bs.modal', () => {
                setTimeout(() => {
                  $termsModalTitle.focus();
                }, 500);
              }).on('hide.bs.modal', () => {
                if (menuBarVisible) {
                  SGAction.showMenuBar();
                }
              }).on('hidden.bs.modal', () => {
                $termsModal.remove();
                that.focus();
              });

              // Show the current modal
              $termsModal.modal({
                backdrop: true,
                show: true,
              });

              const modalHeaderHeight = $termsModalHeader.outerHeight();
              const offsetTop = options.offsetTop + SGViewState.getInset('top');
              const offsetBottom = options.offsetBottom;

              // Calculate the height of the modal body
              $termsModalContent.css({ height: browserHeight - offsetTop - offsetBottom, overflow: 'hidden' });
              $termsModalBody.css({ height: browserHeight - modalHeaderHeight - offsetTop - offsetBottom });
              $termsModal.find('.terms-content').css({ height: browserHeight - modalHeaderHeight - offsetTop - offsetBottom });

              $termsModal.css({ visibility: 'visible' });

              $(document).trigger('shopgateFramework.ui.sanitizeShopgateLinksInElement', [$termsModal.find('.terms-content')]);
            }
          },
          complete: () => {
            $(document).trigger('shopgateFramework.waitingIndicator.hide');
          },
        });
      });
    });
  };
})(jQuery);



// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-terms-modal.js